module.exports = __webpack_public_path__ + "static/heroImage2-8332c7ddaf8578e4a776e054ddb3d779.jpg";